import {Component, computed, input, output} from '@angular/core';

@Component({
  selector: 'app-dot-button',
  standalone: true,
  imports: [],
  templateUrl: './dot-button.component.html',
  styleUrl: './dot-button.component.sass'
})
export class DotButtonComponent {
  readonly index = input<number>(0);
  readonly active = input<number>(0);
  readonly dotClick = output<number>();

  readonly currentlySelected = computed(() => this.index() === this.active());

  handleClick(): void {
    this.dotClick.emit(this.index());
  }
}
